import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ProgressReportsSettingsLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'ProgressReportsSettingsLazy' */ './components/ProgressReportsSettings'
		)
);

export default (store) => {
	return {
		path: 'progress-reports-settings',
		element: <AsyncLoading component={<ProgressReportsSettingsLazy />} />,
	};
};
